import type { DefaultFunctionArgs, FunctionReference } from "convex/server";

export const fn = <Args extends DefaultFunctionArgs = Record<string, never>, Result = unknown>(
  name: string,
) => name as unknown as FunctionReference<"query" | "mutation" | "action", "public", Args, Result>;

export const queryRef = <Args extends DefaultFunctionArgs = Record<string, never>, Result = unknown>(
  name: string,
) => name as unknown as FunctionReference<"query", "public", Args, Result>;

export const mutationRef = <Args extends DefaultFunctionArgs = Record<string, never>, Result = unknown>(
  name: string,
) => name as unknown as FunctionReference<"mutation", "public", Args, Result>;

export const actionRef = <Args extends DefaultFunctionArgs = Record<string, never>, Result = unknown>(
  name: string,
) => name as unknown as FunctionReference<"action", "public", Args, Result>;
